import React from 'react';
import { Link } from 'react-router-dom';

interface TopicNavLinksProps {
  previousSlug?: string | null;
  previousTitle?: string | null;
  previousModuleTitle?: string | null;
  previousHref?: string | null;
  nextSlug?: string | null;
  nextTitle?: string | null;
  nextModuleTitle?: string | null;
  nextHref?: string | null;
  currentModuleTitle?: string | null;
  toTopic: (slug: string) => string;
}

const TopicNavLinks: React.FC<TopicNavLinksProps> = ({
  previousSlug,
  previousTitle,
  previousModuleTitle,
  previousHref,
  nextSlug,
  nextTitle,
  nextModuleTitle,
  nextHref,
  currentModuleTitle,
  toTopic,
}) => {
  const prevTo = previousHref || (previousSlug ? toTopic(previousSlug) : null);
  const nextTo = nextHref || (nextSlug ? toTopic(nextSlug) : null);
  if (!prevTo && !nextTo) return null;

  const prevCrosses = previousModuleTitle && previousModuleTitle !== currentModuleTitle;
  const nextCrosses = nextModuleTitle && nextModuleTitle !== currentModuleTitle;

  return (
    <nav className="mt-12 flex items-start justify-between gap-6" aria-label="Topic">
      {prevTo ? (
        <Link to={prevTo} className="min-w-0 flex-1 text-left font-medium text-primary-600 hover:text-primary-800">
          <span className="block text-xs font-semibold uppercase tracking-wide text-gray-500">
            Previous{prevCrosses ? ` · ${previousModuleTitle}` : ''}
          </span>
          <span className="mt-1 block">← {previousTitle}</span>
        </Link>
      ) : <span className="flex-1" />}
      {nextTo ? (
        <Link to={nextTo} className="min-w-0 flex-1 text-right font-medium text-primary-600 hover:text-primary-800">
          <span className="block text-xs font-semibold uppercase tracking-wide text-gray-500">
            Next{nextCrosses ? ` · ${nextModuleTitle}` : ''}
          </span>
          <span className="mt-1 block">{nextTitle} →</span>
        </Link>
      ) : <span className="flex-1" />}
    </nav>
  );
};

export default TopicNavLinks;
